export default __webpack_public_path__ + "static/media/user-gear-solid-full-navy.145e92b3.svg";